import {
  addMissingRequiredFields,
  checkIsValidEmail,
  checkIsValidName,
  getArrayLength,
  getIsArrayEmpty,
  isEmail,
} from 'utils';
import { AddDataRoomsTableKeys, REQUIRED_COLUMNS, TABLE_COLUMNS } from './data';
import { DataRoomSheet } from 'router/subrouters/DataRoom/models/DataRoom';

export const checkIfColumnIsValid = (column: string) =>
  TABLE_COLUMNS.includes(column as AddDataRoomsTableKeys);

export const checkHasEveryRequiredColumn = (columns: string[]) =>
  REQUIRED_COLUMNS.every((col) => columns.includes(col));

export const addMissingRequiredFieldsToDataRoom = (dataRoom: DataRoomSheet) =>
  addMissingRequiredFields(REQUIRED_COLUMNS, dataRoom) as DataRoomSheet;

export const checkIsDataRoomInvalid = (dataRoom: DataRoomSheet) => {
  const { dataRoomName, ownerEmail, ownerFirstName, ownerLastName } = dataRoom;

  return (
    !dataRoomName ||
    !checkIsValidEmail(ownerEmail) ||
    !checkIsValidName(ownerFirstName) ||
    !checkIsValidName(ownerLastName)
  );
};

export const checkAreAllRequiredFieldsValid = (dataRooms: DataRoomSheet[]) =>
  !dataRooms.some(checkIsDataRoomInvalid);

export const getInvalidDataRoomsCount = (dataRooms: DataRoomSheet[]) =>
  getArrayLength(dataRooms.filter(checkIsDataRoomInvalid));

export const getArrayOfColleagueEmails = (colleagues: any) =>
  (Array.isArray(colleagues)
    ? colleagues
    : typeof colleagues === 'string'
    ? colleagues
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    : []
  )?.filter(isEmail);

export const checkHasInvalidOptionalValues = (dataRoom: DataRoomSheet) => {
  const { colleagues } = dataRoom;

  return !!colleagues && getIsArrayEmpty(getArrayOfColleagueEmails(colleagues));
};

export const getInvalidOptionalDataRoomsCount = (dataRooms: DataRoomSheet[]) =>
  getArrayLength(dataRooms.filter(checkHasInvalidOptionalValues));

export const prepareValuesForApi = (dataRooms: DataRoomSheet[]) =>
  dataRooms.map(({ _id, colleagues, ...rest }) => ({
    ...Object.fromEntries(
      Object.entries(rest).filter(([key]) => checkIfColumnIsValid(key)),
    ),
    colleagues: colleagues ? getArrayOfColleagueEmails(colleagues) : [],
  }));
